import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal, Table, Row, Col } from '_zari/core'

import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import TiposDeDocumentoIdentificacionConstant from 'constants/tiposDeDocumentoIdentificacion'

import * as SociosCrud from 'services/socio.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  tipoDocumento: Yup.string().required(),
  numeroDocumento: Yup.string()
    .required()
    .when('tipoDocumento', {
      is: TiposDeDocumentoIdentificacionConstant.DNI,
      then: Yup.string().min(8).max(8),
      otherwise: Yup.string().when('tipoDocumento', {
        is: TiposDeDocumentoIdentificacionConstant.RUC,
        then: Yup.string().min(11).max(11)
      })
    }),
  nombres: Yup.string().when('tipoDocumento', {
    is: TiposDeDocumentoIdentificacionConstant.DNI,
    then: Yup.string().min(3).max(100).required()
  }),
  // apellidos: Yup.string().when('tipoDocumento', {
  //   is: TiposDeDocumentoIdentificacionConstant.DNI,
  //   then: Yup.string().min(3).max(100).required()
  // }),
  razonSocial: Yup.string().when('tipoDocumento', {
    is: tipoDocumento => tipoDocumento !== TiposDeDocumentoIdentificacionConstant.DNI,
    then: Yup.string().min(3).max(200).required()
  }),
  direccion: Yup.string().min(5).max(200).notRequired(),
  email1: Yup.string().email().max(300).notRequired(),
  email2: Yup.string().email().max(300).notRequired()
})

const NuevoSocioModal = ({ handleClose, show, onCreate, defaultData, onUpdate, edicionData = {} }) => {
  const __zariContext = React.useContext(ZariContext)

  const [arrCodigosAkdemic, setArrCodigosAkdemic] = React.useState([])

  const formInitialValues = React.useMemo(() => {
    let numeroDocumento = ''
    if (defaultData && /^[0-9]{11}$/.test(defaultData.numeroDocumento)) {
      numeroDocumento = defaultData.numeroDocumento
    }

    if (edicionData && edicionData.codigoAkdemic) {
      setArrCodigosAkdemic(
        edicionData.codigoAkdemic.length
          ? edicionData.codigoAkdemic.map((x, k) => {
              return {
                idFila: k,
                codigo: x
              }
            })
          : []
      )
    }

    return {
      tipoDocumento: edicionData.tipoDocumento || TiposDeDocumentoIdentificacionConstant.RUC,
      numeroDocumento: edicionData.numeroDocumento || numeroDocumento,
      nombres: edicionData.nombres || '',
      apellidos: edicionData.apellidos || '',
      razonSocial: edicionData.razonSocial || '',
      sobrenombre: edicionData.sobrenombre || '',
      direccion: edicionData.direccion || '',
      email1: edicionData.email1 || '',
      email2: edicionData.email2 || '',
      comentario: edicionData.comentario || '',
      codigoAkdemic: edicionData.codigoAkdemic || [],
      infoCodigoAkdemic: edicionData.infoCodigoAkdemic || [],
      _idDepartamento: edicionData._idDepartamento || '',
      _idProvincia: edicionData._idProvincia || '',
      _idDistrito: edicionData._idDistrito || ''
    }
  }, [defaultData, edicionData])

  const submitHandler = async nuevoSocioData => {
    if (edicionData) {
      nuevoSocioData._id = edicionData._id
    }

    SociosCrud.nuevoSocioViaVentas(nuevoSocioData)
      .then(({ data }) => {
        __zariContext.snack('success', 'El registros se ha completado.')
        // codigo: "0000000017"
        // facturacionConIgv: true
        // numeroDocumento: "20553856451"
        // razonSocial: "BI GRAND CONFECCIONES S.A.C."
        // tipoDocumento: "6"
        // _id: "2323330a-a5ad-4aa9-946f-44430536296b"
        if (edicionData && edicionData._id) {
          onUpdate({
            razonSocial: nuevoSocioData.razonSocial
          })
        } else {
          onCreate(data)
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal size='md' show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{edicionData._id ? 'ACTUALIZAR CLIENTE' : 'NUEVO CLIENTE'} </Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, handleChange, setValues, setFieldError, setFieldTouched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.TipoDocumentoFormGroup
                iError={errors.tipoDocumento}
                iTouched={touched.tipoDocumento}
                fIsSubmitting={!!edicionData._id || isSubmitting}
              />
              <FormGroups.NumeroDocumentoFormGroup
                handleChange={handleChange}
                setValues={setValues}
                setArrCodigosAkdemic={setArrCodigosAkdemic}
                values={values}
                iError={errors.numeroDocumento}
                iTouched={touched.numeroDocumento}
                vId={edicionData._id}
                fIsSubmitting={!!edicionData._id || isSubmitting}
                setFieldError={setFieldError}
                setFieldTouched={setFieldTouched}
              />
              {values.tipoDocumento === TiposDeDocumentoIdentificacionConstant.DNI ? (
                <>
                  <FormGroups.NombresFormGroup
                    iError={errors.nombres}
                    iTouched={touched.nombres}
                    fIsSubmitting={isSubmitting}
                  />
                  <FormGroups.ApellidosFormGroup
                    iError={errors.apellidos}
                    iTouched={touched.apellidos}
                    fIsSubmitting={isSubmitting}
                  />
                </>
              ) : (
                <FormGroups.RazonSocialFormGroup
                  iError={errors.razonSocial}
                  iTouched={touched.razonSocial}
                  fIsSubmitting={isSubmitting}
                />
              )}
              <FormGroups.DireccionFormGroup
                iError={errors.direccion}
                iTouched={touched.direccion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.Email1FormGroup
                iError={errors.email1}
                iTouched={touched.email1}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.ComentarioFormGroup
                iError={errors.comentario}
                iTouched={touched.comentario}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.CodigoNuevoFormGroup
                iError={errors.comentario}
                iTouched={touched.comentario}
                fIsSubmitting={isSubmitting}
                onClick={e => {
                  let nuevoCodigoAkdemic = values.codigoAkdemic
                  nuevoCodigoAkdemic.push(e)
                  setValues({ ...values, codigoAkdemic: nuevoCodigoAkdemic })
                  setArrCodigosAkdemic(
                    nuevoCodigoAkdemic.map((x, k) => {
                      return {
                        idFila: k,
                        codigo: x
                      }
                    })
                  )
                }}
              />
              <Row>
                <Col md={2} />
                <Col md={8}>
                  <Table.ClientSide
                    headRows={[{ label: 'Nro' }, { label: 'CODIGO' }, { label: 'ESC. PROF.' }, { label: '' }]}
                    filas={arrCodigosAkdemic}
                    rowTemplate={row => (
                      <Table.Row hover key={row.idFila}>
                        <Table.Cell>{row.idFila + 1 || '--'}</Table.Cell>
                        <Table.Cell>{row.codigo || '--'}</Table.Cell>
                        <Table.Cell>
                          {values?.infoCodigoAkdemic.find(x => x.codigo === row.codigo)?.nombreCarrera ?? '--'}
                        </Table.Cell>
                        <Table.Cell>
                          <Table.Dropdown>
                            {({ handleClose }) => [
                              <Table.Dropdown.Item
                                key='eliminar'
                                handleClose={handleClose}
                                onClick={e => {
                                  setArrCodigosAkdemic(arrCodigosAkdemic.filter(x => x.codigo !== row.codigo))
                                  setValues({
                                    ...values,
                                    codigoAkdemic: values.codigoAkdemic.filter(x => x !== row.codigo)
                                  })
                                }}
                              >
                                Eliminar
                              </Table.Dropdown.Item>
                            ]}
                          </Table.Dropdown>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  />
                </Col>
                <Col md={2} />
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}> {edicionData._id ? 'Actualizar' : 'Crear'}</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevoSocioModal)
